const extractIdFromUrl = (url?: string) => {
  if (url) {
    return url?.substring(Number(url?.lastIndexOf("/")) + 1);
  }

  return "";
};

export default extractIdFromUrl;
